/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {KTSVG, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {useAuth} from '../../modules/auth'
import {POS} from './appointment/Pos'
import {useSearchParams} from 'react-router-dom'
import {Booking} from '../../modules/apps/booking/list/core/_models'
import {useIntl} from 'react-intl'

const BarberShop: FC = () => {
  const intl = useIntl()
  const {currentUser, business} = useAuth()
  const [show, setShow] = useState(false)
  const [defaultData, setDefaultData] = useState<Booking>({})
  const [searchParams] = useSearchParams()
  const service_id = searchParams.get('service_id')
  const staff_id = searchParams.get('staff_id')
  useEffect(() => {
    if (service_id) {
      setShow(true)
      setDefaultData((prev) => {
        return {...prev, service_id: Number(service_id)}
      })
    }
    if (staff_id) {
      setShow(true)
      setDefaultData((prev) => {
        return {...prev, staff_id: staff_id}
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [service_id, staff_id])

  return (
    <>
      <div
        className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
        style={{
          backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`,
        }}
      >
        {/*begin::Page*/}
        <div
          className='page launcher sidebar-enabled d-flex flex-row flex-column-fluid me-lg-5'
          id='kt_page'
        >
          {/*begin::Content*/}
          <div className='d-flex flex-row-fluid'>
            {/*begin::Container*/}
            <div className='d-flex flex-column flex-row-fluid align-items-center'>
              {/*begin::Menu*/}
              <div className='d-flex flex-column flex-column-fluid mb-5 mb-lg-10'>
                {/*begin::Brand*/}
                <div className='d-flex flex-center pt-10 pt-lg-0 mb-10 mb-lg-0 h-lg-225px'>
                  {/*begin::Sidebar toggle*/}
                  <div
                    className='btn btn-icon btn-active-color-primary w-30px h-30px d-lg-none me-4 ms-n15'
                    id='kt_sidebar_toggle'
                  >
                    <i className='ki-duotone ki-abstract-14 fs-1'>
                      <span className='path1'></span>
                      <span className='path2'></span>
                    </i>
                  </div>
                  {/*end::Sidebar toggle*/}
                  {/*begin::Logo*/}
                  <span>
                    <img
                      alt='Logo'
                      src={
                        business?.BUSINESS_LOGO
                          ? process.env.REACT_APP_BUCKET_URL + '/' + business.BUSINESS_LOGO
                          : toAbsoluteUrl('/media/logos/default1.png')
                      }
                      className='h-70px'
                    />
                  </span>
                  {/*end::Logo*/}
                </div>
                {/*end::Brand*/}
                {/*begin::Row*/}
                <div className='row g-7 w-xxl-850px'>
                  {/*begin::Col*/}
                  <div className='col-xxl-7'>
                    {/*begin::Card*/}
                    <div
                      className='card border-0 shadow-none min-h-200px mb-7'
                      style={{backgroundColor: '#A838FF'}}
                    >
                      {/*begin::Card body*/}
                      <div className='card-body d-flex flex-center flex-wrap'>
                        {/*begin::Illustrations*/}
                        <img
                          alt='img'
                          className='mw-100 h-200px me-4 mb-5 mb-lg-0'
                          src={toAbsoluteUrl('/media/illustrations/sigma-1/11.png')}
                        />
                        {/*end::Illustrations*/}
                        {/*begin::Wrapper*/}
                        <div
                          className='d-flex flex-column align-items-center align-items-md-start flex-grow-1'
                          data-bs-theme='light'
                        >
                          {/*begin::Heading*/}
                          <h3 className='text-white fw-bolder text-uppercase mb-5'>Quick Guide</h3>
                          {/*end::Heading*/}
                          {/*begin::List*/}
                          <div className='text-white opacity-75 mb-5 text-center text-md-start'>
                            Schedule an appointment
                            <br /> with your desired stylist
                          </div>
                          {/*end::List*/}
                          {/*begin::Link*/}
                          <button
                            type='button'
                            onClick={() => setShow(true)}
                            className='btn btn-hover-rise text-white bg-white bg-opacity-10 text-uppercase fs-7 fw-bold'
                          >
                            Book Appointment
                          </button>
                          {/*end::Link*/}
                        </div>
                        {/*end::Wrapper*/}
                      </div>
                      {/*end::Card body*/}
                    </div>
                    {/*end::Card*/}
                    {/*begin::Row*/}
                    <div className='row g-lg-7'>
                      {/*begin::Col*/}
                      <div className='col-sm-6'>
                        {/*begin::Card*/}
                        <Link
                          to='services'
                          className='card border-0 shadow-none min-h-200px mb-7 mb-lg-0'
                          style={{backgroundColor: '#F9666E'}}
                        >
                          {/*begin::Card body*/}
                          <div className='card-body d-flex flex-column flex-center text-center'>
                            {/*begin::Illustrations*/}
                            <img
                              alt='img'
                              className='mw-100 h-100px mb-7 mx-auto'
                              src={toAbsoluteUrl('/media/illustrations/sigma-1/4.png')}
                            />
                            {/*end::Illustrations*/}
                            {/*begin::Heading*/}
                            <button
                              type='button'
                              onClick={() => setShow(true)}
                              className='btn btn-hover-rise text-white bg-white bg-opacity-10 text-uppercase fs-7 fw-bold'
                            >
                              View Catalogue
                            </button>
                            {/* <h4 className='text-white fw-bold text-uppercase'>View Catalogue</h4> */}
                            {/*end::Heading*/}
                          </div>
                          {/*end::Card body*/}
                        </Link>
                        {/*end::Card*/}
                      </div>
                      {/*end::Col*/}
                      {/*begin::Col*/}
                      <div className='col-sm-6'>
                        {/*begin::Card*/}
                        <Link
                          to='staffs'
                          className='card border-0 shadow-none min-h-200px mb-7 mb-lg-0'
                          style={{backgroundColor: '#35D29A'}}
                        >
                          {/*begin::Card body*/}
                          <div className='card-body d-flex flex-column flex-center text-center'>
                            {/*begin::Illustrations*/}
                            <img
                              alt='img'
                              className='mw-100 h-100px mb-7 mx-auto'
                              src={toAbsoluteUrl('/media/illustrations/sigma-1/5.png')}
                            />
                            {/*end::Illustrations*/}
                            {/*begin::Heading*/}
                            <button
                              type='button'
                              onClick={() => setShow(true)}
                              className='btn btn-hover-rise text-white bg-white bg-opacity-10 text-uppercase fs-7 fw-bold'
                            >
                              Stylists
                            </button>
                            {/* <h4 className='text-white fw-bold text-uppercase'>Stylists</h4> */}
                            {/*end::Heading*/}
                          </div>
                          {/*end::Card body*/}
                        </Link>
                        {/*end::Card*/}
                      </div>
                      {/*end::Col*/}
                    </div>
                    {/*end::Row*/}
                  </div>
                  {/*end::Col*/}
                  {/*begin::Col*/}
                  <div className='col-xxl-5'>
                    {/*begin::Card*/}
                    <div
                      className='card border-0 shadow-none h-lg-100'
                      style={{backgroundColor: '#A838FF'}}
                    >
                      {/*begin::Card body*/}
                      <div className='card-body d-flex flex-column flex-center pb-0 pt-15'>
                        {/*begin::Wrapper*/}
                        <div className='px-10 mb-10'>
                          {/*begin::Heading*/}
                          <h3 className='text-white mb-2 fw-bolder ttext-center text-uppercase mb-6'>
                            Sell On Metronic
                          </h3>
                          {/*end::Heading*/}
                          {/*begin::List*/}
                          <div className='mb-7'>
                            {/*begin::Item*/}
                            <div className='d-flex align-items-center mb-2'>
                              <i className='ki-duotone ki-black-right fs-4 text-white opacity-75 me-3'></i>
                              <span className='text-white opacity-75'>Easy Tool</span>
                            </div>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <div className='d-flex align-items-center mb-2'>
                              <i className='ki-duotone ki-black-right fs-4 text-white opacity-75 me-3'></i>
                              <span className='text-white opacity-75'>Fast Reports</span>
                            </div>
                            {/*end::Item*/}
                            {/*begin::Item*/}
                            <div className='d-flex align-items-center mb-2'>
                              <i className='ki-duotone ki-black-right fs-4 text-white opacity-75 me-3'></i>
                              <span className='text-white opacity-75'>Up To 75% Share</span>
                            </div>
                            {/*end::Item*/}
                          </div>
                          {/*end::List*/}
                          {/*begin::Link*/}
                          {currentUser ? (
                            <Link
                              to='/'
                              className='btn btn-hover-rise text-white bg-white bg-opacity-10 text-uppercase fs-7 fw-bold'
                            >
                              Go To Dashboard
                            </Link>
                          ) : (
                            <Link
                              to='/auth'
                              className='btn btn-hover-rise text-white bg-white bg-opacity-10 text-uppercase fs-7 fw-bold'
                            >
                              Sign In
                            </Link>
                          )}
                          {/*end::Link*/}
                        </div>
                        {/*end::Wrapper*/}
                        {/*begin::Illustrations*/}
                        <img
                          alt='img'
                          className='mw-100 h-225px mx-auto mb-lg-n18'
                          src={toAbsoluteUrl('/media/illustrations/sigma-1/12.png')}
                        />
                        {/*end::Illustrations*/}
                      </div>
                      {/*end::Card body*/}
                    </div>
                    {/*end::Card*/}
                  </div>
                  {/*end::Col*/}
                </div>
                {/*end::Row*/}
              </div>
              {/*end::Menu*/}
              {/*begin::Footer*/}
              <div className='d-flex flex-column-auto flex-center'>
                {/*begin::Navs*/}
                <ul className='menu fw-semibold order-1'>
                  <li className='menu-item'>
                    <a
                      href='https://keenthemes.com'
                      target='_blank'
                      className='menu-link text-white opacity-50 opacity-100-hover px-3'
                      rel='noreferrer'
                    >
                      About
                    </a>
                  </li>
                  <li className='menu-item'>
                    <a
                      href='https://preview.keenthemes.com/html/metronic/docs'
                      target='_blank'
                      className='menu-link text-white opacity-50 opacity-100-hover px-3'
                      rel='noreferrer'
                    >
                      Documentation
                    </a>
                  </li>
                  <li className='menu-item'>
                    <a
                      href='https://devs.keenthemes.com'
                      target='_blank'
                      className='menu-link text-white opacity-50 opacity-100-hover px-3'
                      rel='noreferrer'
                    >
                      Support
                    </a>
                  </li>
                  <li className='menu-item'>
                    <a
                      href='https://1.envato.market/EA4JP'
                      target='_blank'
                      className='menu-link text-white opacity-50 opacity-100-hover px-3'
                      rel='noreferrer'
                    >
                      Purchase
                    </a>
                  </li>
                </ul>
                {/*end::Navs*/}
              </div>
              {/*end::Footer*/}
            </div>
            {/*begin::Content*/}
          </div>
          {/*begin::Content*/}
          {/*begin::Sidebar*/}
          <div
            id='kt_sidebar'
            className='sidebar px-5 py-5 py-lg-8 px-lg-11'
            data-kt-drawer='true'
            data-kt-drawer-name='sidebar'
            data-kt-drawer-activate='{default: true, lg: false}'
            data-kt-drawer-overlay='true'
            data-kt-drawer-width='375px'
            data-kt-drawer-direction='end'
            data-kt-drawer-toggle='#kt_sidebar_toggle'
          >
            {/*begin::Header*/}
            <div className='d-flex flex-stack mb-5 mb-lg-8' id='kt_sidebar_header'>
              {/*begin::Title*/}
              <h2 className='text-white'>Updates</h2>
              {/*end::Title*/}
              {/*begin::Menu*/}
              <div className='ms-1'>
                <button
                  className='btn btn-icon btn-sm btn-color-white btn-active-color-primary me-n5'
                  data-kt-menu-trigger='click'
                  data-kt-menu-placement='bottom-end'
                  data-kt-menu-overflow='true'
                >
                  <i className='ki-duotone ki-dots-square fs-2'>
                    <span className='path1'></span>
                    <span className='path2'></span>
                    <span className='path3'></span>
                    <span className='path4'></span>
                  </i>
                </button>
                {/*begin::Menu 2*/}
                <div
                  className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px'
                  data-kt-menu='true'
                >
                  {/*begin::Menu item*/}
                  <div className='menu-item px-3'>
                    <div className='menu-content fs-6 text-dark fw-bold px-3 py-4'>
                      Quick Actions
                    </div>
                  </div>
                  {/*end::Menu item*/}
                  {/*begin::Menu separator*/}
                  <div className='separator mb-3 opacity-75'></div>
                  {/*end::Menu separator*/}
                  {/*begin::Menu item*/}
                  <div className='menu-item px-3'>
                    <a href='#' className='menu-link px-3'>
                      New Ticket
                    </a>
                  </div>
                  {/*end::Menu item*/}
                  {/*begin::Menu item*/}
                  <div className='menu-item px-3'>
                    <a href='#' className='menu-link px-3'>
                      New {intl.formatMessage({id: 'Customer'})}
                    </a>
                  </div>
                  {/*end::Menu item*/}
                  {/*begin::Menu item*/}
                  <div
                    className='menu-item px-3'
                    data-kt-menu-trigger='hover'
                    data-kt-menu-placement='right-start'
                  >
                    {/*begin::Menu item*/}
                    <a href='#' className='menu-link px-3'>
                      <span className='menu-title'>New Group</span>
                      <span className='menu-arrow'></span>
                    </a>
                    {/*end::Menu item*/}
                    {/*begin::Menu sub*/}
                    <div className='menu-sub menu-sub-dropdown w-175px py-4'>
                      {/*begin::Menu item*/}
                      <div className='menu-item px-3'>
                        <a href='#' className='menu-link px-3'>
                          Admin Group
                        </a>
                      </div>
                      {/*end::Menu item*/}
                      {/*begin::Menu item*/}
                      <div className='menu-item px-3'>
                        <a href='#' className='menu-link px-3'>
                          {intl.formatMessage({id: 'Staff'})} Group
                        </a>
                      </div>
                      {/*end::Menu item*/}
                      {/*begin::Menu item*/}
                      <div className='menu-item px-3'>
                        <a href='#' className='menu-link px-3'>
                          Member Group
                        </a>
                      </div>
                      {/*end::Menu item*/}
                    </div>
                    {/*end::Menu sub*/}
                  </div>
                  {/*end::Menu item*/}
                  {/*begin::Menu item*/}
                  <div className='menu-item px-3'>
                    <a href='#' className='menu-link px-3'>
                      New Contact
                    </a>
                  </div>
                  {/*end::Menu item*/}
                  {/*begin::Menu separator*/}
                  <div className='separator mt-3 opacity-75'></div>
                  {/*end::Menu separator*/}
                  {/*begin::Menu item*/}
                  <div className='menu-item px-3'>
                    <div className='menu-content px-3 py-3'>
                      <a className='btn btn-primary btn-sm px-4' href='#'>
                        Generate Reports
                      </a>
                    </div>
                  </div>
                  {/*end::Menu item*/}
                </div>
                {/*end::Menu 2*/}
                {/*end::Menu*/}
              </div>
            </div>
            {/*end::Header*/}
            {/*begin::Body*/}
            <div className='mb-5 mb-lg-8' id='kt_sidebar_body'>
              {/*begin::Scroll*/}
              <div
                className='hover-scroll-y me-n6 pe-6'
                id='kt_sidebar_body'
                data-kt-scroll='true'
                data-kt-scroll-height='auto'
                data-kt-scroll-dependencies='#kt_sidebar_header, #kt_sidebar_footer'
                data-kt-scroll-wrappers='#kt_page, #kt_sidebar, #kt_sidebar_body'
                data-kt-scroll-offset='0'
              >
                {/*begin::Timeline items*/}
                <div className='timeline'>
                  {/*begin::Timeline item*/}
                  <div className='timeline-item'>
                    {/*begin::Timeline line*/}
                    <div className='timeline-line w-40px'></div>
                    {/*end::Timeline line*/}
                    {/*begin::Timeline icon*/}
                    <div className='timeline-icon symbol symbol-circle symbol-40px me-4'>
                      <div className='symbol-label'>
                        <i className='ki-duotone ki-message-text-2 fs-2 text-white'>
                          <span className='path1'></span>
                          <span className='path2'></span>
                          <span className='path3'></span>
                        </i>
                      </div>
                    </div>
                    {/*end::Timeline icon*/}
                    {/*begin::Timeline content*/}
                    <div className='timeline-content mb-10 mt-n1'>
                      {/*begin::Timeline heading*/}
                      <div className='pe-3 mb-5'>
                        {/*begin::Title*/}
                        <div className='fs-5 fw-semibold mb-2 text-white'>
                          Created 2 new tasks in "Development"
                        </div>
                        {/*end::Title*/}
                        {/*begin::Description*/}
                        <div className='d-flex align-items-center mt-1 fs-6'>
                          {/*begin::Info*/}
                          <div className='text-white opacity-50 me-2 fs-7'>Added at 4:23 PM by</div>
                          {/*end::Info*/}
                          {/*begin::User*/}
                          <div
                            className='symbol symbol-circle symbol-25px'
                            data-bs-toggle='tooltip'
                            data-bs-boundary='window'
                            data-bs-placement='top'
                            title='Nina Nilson'
                          >
                            <img alt='img' src={toAbsoluteUrl('/media/avatars/300-14.jpg')} />
                          </div>
                          {/*end::User*/}
                        </div>
                        {/*end::Description*/}
                      </div>
                      {/*end::Timeline heading*/}
                      {/*begin::Timeline details*/}
                      <div className='pb-5'>
                        {/*begin::Record*/}
                        <div className='d-flex flex-stack border rounded px-7 py-3'>
                          {/*begin::Title*/}
                          <a
                            href='#'
                            className='fs-5 text-white text-hover-success fw-semibold w-375px'
                          >
                            Meeting with {intl.formatMessage({id: 'Customer'})}
                          </a>
                          {/*end::Title*/}
                          {/*begin::Action*/}
                          <a
                            href='#'
                            className='btn btn-sm btn-hover-rise text-white bg-white bg-opacity-10'
                          >
                            View
                          </a>
                          {/*end::Action*/}
                        </div>
                        {/*end::Record*/}
                      </div>
                      {/*end::Timeline details*/}
                    </div>
                    {/*end::Timeline content*/}
                  </div>
                  {/*end::Timeline item*/}
                  {/*begin::Timeline item*/}
                  <div className='timeline-item'>
                    {/*begin::Timeline line*/}
                    <div className='timeline-line w-40px'></div>
                    {/*end::Timeline line*/}
                    {/*begin::Timeline icon*/}
                    <div className='timeline-icon symbol symbol-circle symbol-40px'>
                      <div className='symbol-label'>
                        <i className='ki-duotone ki-pointers fs-2 text-white'>
                          <span className='path1'></span>
                          <span className='path2'></span>
                          <span className='path3'></span>
                        </i>
                      </div>
                    </div>
                    {/*end::Timeline icon*/}
                    {/*begin::Timeline content*/}
                    <div className='timeline-content mb-10 mt-n2'>
                      {/*begin::Timeline heading*/}
                      <div className='pe-3'>
                        {/*begin::Title*/}
                        <div className='fs-5 text-white fw-semibold mb-2'>
                          2 new entries in "Landing Page"
                        </div>
                        {/*end::Title*/}
                        {/*begin::Description*/}
                        <div className='d-flex align-items-center mt-1 fs-6'>
                          {/*begin::Info*/}
                          <div className='text-white opacity-50 me-2 fs-7'>4:23 PM by</div>
                          {/*end::Info*/}
                          <a href='#' className='text-success fs-7 fw-bold'>
                            Adam Williams
                          </a>
                        </div>
                        {/*end::Description*/}
                      </div>
                      {/*end::Timeline heading*/}
                    </div>
                    {/*end::Timeline content*/}
                  </div>
                  {/*end::Timeline item*/}
                  {/*begin::Timeline item*/}
                  <div className='timeline-item'>
                    {/*begin::Timeline line*/}
                    <div className='timeline-line w-40px'></div>
                    {/*end::Timeline line*/}
                    {/*begin::Timeline icon*/}
                    <div className='timeline-icon symbol symbol-circle symbol-40px'>
                      <div className='symbol-label'>
                        <i className='ki-duotone ki-disconnect fs-2 text-white'>
                          <span className='path1'></span>
                          <span className='path2'></span>
                          <span className='path3'></span>
                          <span className='path4'></span>
                          <span className='path5'></span>
                        </i>
                      </div>
                    </div>
                    {/*end::Timeline icon*/}
                    {/*begin::Timeline content*/}
                    <div className='timeline-content mb-10 mt-n1'>
                      {/*begin::Timeline heading*/}
                      <div className='mb-5 pe-3'>
                        {/*begin::Title*/}
                        <a href='#' className='fs-5 fw-semibold text-white text-hover-success mb-2'>
                          3 New Incoming Project Files
                        </a>
                        {/*end::Title*/}
                        {/*begin::Description*/}
                        <div className='d-flex align-items-center mt-1 fs-6'>
                          {/*begin::Info*/}
                          <div className='text-white opacity-50 me-2 fs-7'>Sent at 10:30 PM by</div>
                          {/*end::Info*/}
                          {/*begin::User*/}
                          <a href='#' className='text-success fs-7 fw-bold'>
                            You
                          </a>
                          {/*end::User*/}
                        </div>
                        {/*end::Description*/}
                      </div>
                      {/*end::Timeline heading*/}
                      {/*begin::Timeline details*/}
                      <div className='pb-5'>
                        {/*begin::Item*/}
                        <div className='d-flex flex-stack border rounded p-4 mb-5'>
                          {/*begin::Wrapper*/}
                          <div className='d-flex align-items-center me-2'>
                            {/*begin::Icon*/}
                            <img
                              alt='img'
                              className='w-30px me-3'
                              src={toAbsoluteUrl('/media/svg/files/doc.svg')}
                            />
                            {/*end::Icon*/}
                            {/*begin::Info*/}
                            <div className='d-flex flex-stack'>
                              {/*begin::Info*/}
                              <div className='d-flex flex-column me-2'>
                                {/*begin::Desc*/}
                                <a href='#' className='fs-7 text-white text-hover-success fw-bold'>
                                  App Guidelines
                                </a>
                                {/*end::Desc*/}
                                {/*begin::Number*/}
                                <div className='text-white opacity-75'>1.9mb</div>
                                {/*end::Number*/}
                              </div>
                              {/*end::Info*/}
                            </div>
                            {/*begin::Info*/}
                          </div>
                          {/*end::Wrapper*/}
                          {/*begin::Action*/}
                          <a
                            href='#'
                            className='btn btn-sm btn-hover-rise text-white bg-white bg-opacity-10'
                          >
                            View
                          </a>
                          {/*end::Action*/}
                        </div>
                        {/*end::Item*/}
                        {/*begin::Item*/}
                        <div className='d-flex flex-stack border rounded p-4'>
                          {/*begin::Wrapper*/}
                          <div className='d-flex align-items-center me-2'>
                            {/*begin::Icon*/}
                            <img
                              alt='img'
                              className='w-30px me-3'
                              src={toAbsoluteUrl('/media/svg/files/pdf.svg')}
                            />
                            {/*end::Icon*/}
                            {/*begin::Info*/}
                            <div className='d-flex flex-stack'>
                              {/*begin::Info*/}
                              <div className='d-flex flex-column me-2'>
                                {/*begin::Desc*/}
                                <a href='#' className='fs-7 text-white text-hover-success fw-bold'>
                                  Reports
                                </a>
                                {/*end::Desc*/}
                                {/*begin::Number*/}
                                <div className='text-gray-400'>2.5mb</div>
                                {/*end::Number*/}
                              </div>
                              {/*end::Info*/}
                            </div>
                            {/*begin::Info*/}
                          </div>
                          {/*end::Wrapper*/}
                          {/*begin::Action*/}
                          <a
                            href='#'
                            className='btn btn-sm btn-hover-rise text-white bg-white bg-opacity-10'
                          >
                            View
                          </a>
                          {/*end::Action*/}
                        </div>
                        {/*end::Item*/}
                      </div>
                      {/*end::Timeline details*/}
                    </div>
                    {/*end::Timeline content*/}
                  </div>
                  {/*end::Timeline item*/}
                  {/*begin::Timeline item*/}
                  <div className='timeline-item'>
                    {/*begin::Timeline line*/}
                    <div className='timeline-line w-40px'></div>
                    {/*end::Timeline line*/}
                    {/*begin::Timeline icon*/}
                    <div className='timeline-icon symbol symbol-circle symbol-40px'>
                      <div className='symbol-label'>
                        <i className='ki-duotone ki-abstract-26 fs-2 text-white'>
                          <span className='path1'></span>
                          <span className='path2'></span>
                        </i>
                      </div>
                    </div>
                    {/*end::Timeline icon*/}
                    {/*begin::Timeline content*/}
                    <div className='timeline-content mb-10 mt-n2'>
                      {/*begin::Timeline heading*/}
                      <div className='pe-3'>
                        {/*begin::Title*/}
                        <div className='fs-5 text-white fw-semibold mb-2'>
                          <a href='#' className='text-success'>
                            KTApp.js
                          </a>
                          &nbsp;has new merged into Master
                        </div>
                        {/*end::Title*/}
                        {/*begin::Description*/}
                        <div className='d-flex align-items-center mt-1 fs-6'>
                          {/*begin::Info*/}
                          <div className='text-white opacity-50 me-2 fs-7'>5:30 AM by</div>
                          {/*end::Info*/}
                          <a href='#' className='text-success fs-7 fw-bold'>
                            Nick Stone
                          </a>
                        </div>
                        {/*end::Description*/}
                      </div>
                      {/*end::Timeline heading*/}
                    </div>
                    {/*end::Timeline content*/}
                  </div>
                  {/*end::Timeline item*/}
                  {/*begin::Timeline item*/}
                  <div className='timeline-item'>
                    {/*begin::Timeline line*/}
                    <div className='timeline-line w-40px'></div>
                    {/*end::Timeline line*/}
                    {/*begin::Timeline icon*/}
                    <div className='timeline-icon symbol symbol-circle symbol-40px'>
                      <div className='symbol-label'>
                        <i className='ki-duotone ki-sms fs-2 text-white'>
                          <span className='path1'></span>
                          <span className='path2'></span>
                        </i>
                      </div>
                    </div>
                    {/*end::Timeline icon*/}
                    {/*begin::Timeline content*/}
                    <div className='timeline-content mb-10 mt-n2'>
                      {/*begin::Timeline heading*/}
                      <div className='pe-3'>
                        {/*begin::Title*/}
                        <div className='fs-5 text-white fw-semibold mb-2'>
                          2 new notifications received
                        </div>
                        {/*end::Title*/}
                        {/*begin::Description*/}
                        <div className='d-flex align-items-center mt-1 fs-6'>
                          {/*begin::Info*/}
                          <div className='text-white opacity-50 me-2 fs-7'>10:30 AM by</div>
                          {/*end::Info*/}
                          <a href='#' className='text-success fs-7 fw-bold'>
                            Marcus Fold
                          </a>
                        </div>
                        {/*end::Description*/}
                      </div>
                      {/*end::Timeline heading*/}
                    </div>
                    {/*end::Timeline content*/}
                  </div>
                  {/*end::Timeline item*/}
                  {/*begin::Timeline item*/}
                  <div className='timeline-item'>
                    {/*begin::Timeline line*/}
                    <div className='timeline-line w-40px'></div>
                    {/*end::Timeline line*/}
                    {/*begin::Timeline icon*/}
                    <div className='timeline-icon symbol symbol-circle symbol-40px'>
                      <div className='symbol-label'>
                        <i className='ki-duotone ki-pencil fs-2 text-white'>
                          <span className='path1'></span>
                          <span className='path2'></span>
                        </i>
                      </div>
                    </div>
                    {/*end::Timeline icon*/}
                    {/*begin::Timeline content*/}
                    <div className='timeline-content mb-10 mt-n1'>
                      {/*begin::Timeline heading*/}
                      <div className='mb-5 pe-3'>
                        {/*begin::Title*/}
                        <a href='#' className='fs-5 fw-semibold text-white text-hover-success mb-2'>
                          You have received a payment
                        </a>
                        {/*end::Title*/}
                        {/*begin::Description*/}
                        <div className='d-flex align-items-center mt-1 fs-6'>
                          {/*begin::Info*/}
                          <div className='text-white opacity-50 me-2 fs-7'>10.40 PM by</div>
                          {/*end::Info*/}
                          {/*begin::User*/}
                          <a href='#' className='text-success fs-7 fw-bold'>
                            Keenthemes
                          </a>
                          {/*end::User*/}
                        </div>
                        {/*end::Description*/}
                      </div>
                      {/*end::Timeline heading*/}
                      {/*begin::Timeline details*/}
                      <div className='pb-5'>
                        {/*begin::Item*/}
                        <div className='d-flex flex-stack border rounded p-4'>
                          {/*begin::Wrapper*/}
                          <div className='d-flex align-items-center me-2'>
                            {/*begin::Icon*/}
                            <i className='ki-duotone ki-bank fs-2x text-white me-4'>
                              <span className='path1'></span>
                              <span className='path2'></span>
                            </i>
                            {/*end::Icon*/}
                            {/*begin::Info*/}
                            <div className='d-flex flex-stack'>
                              {/*begin::Info*/}
                              <div className='d-flex flex-column me-2'>
                                {/*begin::Desc*/}
                                <a href='#' className='fs-7 text-white text-hover-success fw-bold'>
                                  Withdrawing Funds
                                </a>
                                {/*end::Desc*/}
                                {/*begin::Number*/}
                                <div className='text-white opacity-75'>Ref: #ert-78</div>
                                {/*end::Number*/}
                              </div>
                              {/*end::Info*/}
                            </div>
                            {/*begin::Info*/}
                          </div>
                          {/*end::Wrapper*/}
                          {/*begin::Action*/}
                          <a
                            href='#'
                            className='btn btn-sm btn-hover-rise text-white bg-white bg-opacity-10'
                          >
                            View
                          </a>
                          {/*end::Action*/}
                        </div>
                        {/*end::Item*/}
                      </div>
                      {/*end::Timeline details*/}
                    </div>
                    {/*end::Timeline content*/}
                  </div>
                  {/*end::Timeline item*/}
                  {/*begin::Timeline item*/}
                  <div className='timeline-item'>
                    {/*begin::Timeline line*/}
                    <div className='timeline-line w-40px'></div>
                    {/*end::Timeline line*/}
                    {/*begin::Timeline icon*/}
                    <div className='timeline-icon symbol symbol-circle symbol-40px'>
                      <div className='symbol-label'>
                        <i className='ki-duotone ki-basket fs-2 text-white'>
                          <span className='path1'></span>
                          <span className='path2'></span>
                          <span className='path3'></span>
                          <span className='path4'></span>
                        </i>
                      </div>
                    </div>
                    {/*end::Timeline icon*/}
                    {/*begin::Timeline content*/}
                    <div className='timeline-content mt-n1'>
                      {/*begin::Timeline heading*/}
                      <div className='pe-3'>
                        {/*begin::Title*/}
                        <div className='fs-5 text-white fw-semibold mb-2'>
                          2 new entries in UI Design”
                        </div>
                        {/*end::Title*/}
                        {/*begin::Description*/}
                        <div className='d-flex align-items-center mt-1 fs-6'>
                          {/*begin::Info*/}
                          <div className='text-white opacity-50 me-2 fs-7'>10:30 AM by</div>
                          {/*end::Info*/}
                          <a href='#' className='text-success fs-7 fw-bold'>
                            Lisa Wong
                          </a>
                        </div>
                        {/*end::Description*/}
                      </div>
                      {/*end::Timeline heading*/}
                    </div>
                    {/*end::Timeline content*/}
                  </div>
                  {/*end::Timeline item*/}
                </div>
                {/*end::Timeline items*/}
              </div>
              {/*end::Scroll*/}
            </div>
            {/*end::Body*/}
            {/*begin::Footer*/}
            <div className='text-center' id='kt_sidebar_footer'>
              {/*begin::Link*/}
              <a
                href='../../demo10/dist/pages/user-profile/activity.html'
                className='btn btn-hover-rise text-white bg-white bg-opacity-10 text-uppercase fs-7 fw-bold'
              >
                View Updates
              </a>
              {/*end::Link*/}
            </div>
            {/*end::Footer*/}
          </div>
          {/*end::Sidebar*/}
        </div>
        {/*end::Page*/}
      </div>
      {show && <BookingModal setShow={setShow} defaultData={defaultData} />}
    </>
  )
}

const BarberShopWrapper: FC = () => {
  return (
    <>
      <BarberShop />
    </>
  )
}

export {BarberShopWrapper}

const BookingModal: FC<{setShow: any; defaultData: any}> = ({setShow, defaultData}) => {
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_location'
        role='dialog'
        tabIndex={-1}
        // aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-fullscreen p-3 p-lg-9'>
          {/* begin::Modal content */}
          <div className='modal-content bg-light'>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>Make an Appointment</h2>
              {/* end::Modal title */}

              {/* begin::Close */}
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-locations-modal-action='close'
                onClick={() => setShow(false)}
                style={{cursor: 'pointer'}}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>
            {/* begin::Modal body */}
            <div className='modal-body scroll-y my-7'>
              <POS defaultData={defaultData} />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}
